import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _BlankTypeSelect;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { Text } from '@instructure/ui-text';
import { jsx } from '@instructure/emotion';
import BlankChoices from './blank_type_options/BlankChoices';
import WordBankCorrectAnswer from './blank_type_options/WordBankCorrectAnswer';
import OpenEntry from './components/OpenEntry';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { setupDefaultEditDistance, setupDefaultSpecifiedAnswers, setupDefaultChoices } from './blank_type_options/defaultOpenEntry';
import t from '@instructure/quiz-i18n/format-message';
import { SimpleSelect, withStyleOverrides } from '@instructure/quiz-common';
var BlankTypeSelect = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_BlankTypeSelect = /*#__PURE__*/function (_Component) {
  function BlankTypeSelect() {
    var _this2;
    _classCallCheck(this, BlankTypeSelect);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, BlankTypeSelect, [].concat(args));
    _defineProperty(_this2, "select", null);
    _defineProperty(_this2, "updateBlankAnswerType", function (e, _ref) {
      var answerType = _ref.value;
      if (answerType === _this2.props.answerType) return;
      var hasChoices = _this2.props.choices && _this2.props.choices.length;
      if (answerType === 'openEntry') {
        _this2.__updateToNewOpenEntryType('TextContainsAnswer');
        // Setting choices to null removes the choices from the blank
        _this2.props.updateBlank({
          choices: null,
          answerType: answerType
        });
      } else if (_this2.props.useCommonWordbank) {
        if (answerType === 'wordbank') {
          _this2.__updateToNewWordbankType(answerType);
        } else {
          _this2.__updateToNewChoicesType(answerType);
        }
      } else if (hasChoices) {
        _this2.props.updateBlank({
          answerType: answerType
        });
      } else {
        _this2.__updateToNewChoicesType(answerType);
      }
    });
    _defineProperty(_this2, "updateBlankTextMatch", function (e, _ref2) {
      var value = _ref2.value;
      _this2.__updateToNewOpenEntryType(value);
    });
    _defineProperty(_this2, "handleSelectRef", function (node) {
      _this2.select = node;
    });
    return _this2;
  }
  _inherits(BlankTypeSelect, _Component);
  return _createClass(BlankTypeSelect, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.focusOnMount) {
        this.select.focus();
      }
    }

    // allows tests to stub uuid generation
  }, {
    key: "uuid",
    value: function uuid() {
      return this.props.uuid();
    }

    // ===========
    //   ACTIONS
    // ===========
  }, {
    key: "__updateToNewOpenEntryType",
    value: function __updateToNewOpenEntryType(scoringAlgorithm) {
      var blankText = this.props.blankScoringData.blankText;
      var scoringData;
      switch (scoringAlgorithm) {
        case 'TextRegex':
        case 'TextContainsAnswer':
        case 'TextEquivalence':
        case 'Equivalence':
          this.props.updateBlankScoringData({
            scoringData: {
              value: blankText,
              blankText: blankText
            },
            scoringAlgorithm: scoringAlgorithm
          });
          break;
        case 'TextCloseEnough':
          scoringData = setupDefaultEditDistance(blankText);
          this.props.updateBlankScoringData({
            scoringData: scoringData,
            scoringAlgorithm: scoringAlgorithm
          });
          break;
        case 'TextInChoices':
          scoringData = setupDefaultSpecifiedAnswers(blankText);
          this.props.updateBlankScoringData({
            scoringData: scoringData,
            scoringAlgorithm: scoringAlgorithm
          });
          break;
      }
    }
  }, {
    key: "__updateToNewWordbankType",
    value: function __updateToNewWordbankType(answerType) {
      var blankText = this.props.blankScoringData.blankText;
      var choice = {
        id: this.uuid(),
        itemBody: blankText
      };
      this.props.updateBlankScoringData({
        scoringData: {
          value: blankText,
          blankText: blankText,
          choiceId: choice.id
        },
        scoringAlgorithm: 'TextEquivalence'
      });
      this.props.updateBlank({
        answerType: answerType,
        choice: choice,
        choices: null
      });
    }
  }, {
    key: "__updateToNewChoicesType",
    value: function __updateToNewChoicesType(answerType) {
      var mods = setupDefaultChoices(this.props.blankScoringData.blankText);
      this.props.updateBlankScoringData({
        scoringData: mods.scoringData,
        scoringAlgorithm: 'Equivalence'
      });
      this.props.updateBlank({
        choices: mods.choices,
        answerType: answerType
      });
    }
  }, {
    key: "renderContentForAnswerType",
    value:
    // =============
    //   RENDERING
    // =============

    function renderContentForAnswerType() {
      if (this.props.answerType === 'openEntry') {
        return jsx(OpenEntry, {
          blankScoringAlgorithm: this.props.blankScoringAlgorithm,
          blankScoringData: this.props.blankScoringData,
          disabled: this.props.disabled,
          name: this.props.name,
          notifyScreenreader: this.props.notifyScreenreader,
          scoringDataErrors: this.props.scoringDataErrors,
          validationErrorsFromApi: this.props.validationErrorsFromApi,
          updateBlankScoringData: this.props.updateBlankScoringData,
          updateBlankTextMatch: this.updateBlankTextMatch
        });
      }
      if (this.props.answerType === 'wordbank' && this.props.wordBankChoices) {
        return jsx(WordBankCorrectAnswer, {
          blankName: this.props.name,
          disabled: this.props.disabled,
          scoringDataErrors: this.props.scoringDataErrors,
          scoringDataForBlank: this.props.blankScoringData,
          updateScoringDataForBlank: this.props.updateBlankScoringData
        });
      }
      return jsx(BlankChoices, {
        blankName: this.props.name,
        choices: this.props.choices.slice().sort(function (a, b) {
          return a.position - b.position;
        }),
        disabled: this.props.disabled,
        errors: this.props.choicesErrors,
        interactionDataErrors: this.props.interactionDataErrors,
        notifyScreenreader: this.props.notifyScreenreader,
        onModalClose: this.props.onModalClose,
        onModalOpen: this.props.onModalOpen,
        scoringDataErrors: this.props.scoringDataErrors,
        scoringDataForBlank: this.props.blankScoringData,
        updateBlank: this.props.updateBlank,
        updateScoringDataForBlank: this.props.updateBlankScoringData
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        answerType = _this$props.answerType,
        blankScoringData = _this$props.blankScoringData;
      return jsx("div", {
        css: this.props.styles.mainWrapper
      }, jsx("div", {
        css: this.props.styles.blankText
      }, jsx("span", {
        css: this.props.styles.numCircle,
        "aria-hidden": "true",
        role: "presentation"
      }, this.props.blankPosition), jsx(ScreenReaderContent, null, t('Blank {blankNumber, number}', {
        blankNumber: this.props.blankPosition
      })), jsx(Text, {
        weight: "bold"
      }, blankScoringData.blankText)), jsx("div", {
        css: this.props.styles.optionsWrapper
      }, jsx("div", {
        css: this.props.styles.selectWrapper
      }, jsx(SimpleSelect, {
        ref: this.handleSelectRef,
        interaction: this.props.disabled ? 'disabled' : 'enabled',
        renderLabel: jsx("span", null, t('Answer Type')),
        onChange: this.updateBlankAnswerType,
        defaultValue: answerType,
        assistiveText: t('Answer Type dropdown for Blank {blankNumber, number}', {
          blankNumber: this.props.blankPosition
        })
      }, jsx(SimpleSelect.Option, {
        id: "blank-type-select-option-open-entry",
        value: "openEntry"
      }, t('Open Entry')), jsx(SimpleSelect.Option, {
        id: "blank-type-select-option-dropdown",
        value: "dropdown"
      }, t('Dropdown')), jsx(SimpleSelect.Option, {
        id: "blank-type-select-option-word-bank",
        value: "wordbank"
      }, t('Word Bank')))), jsx("div", {
        css: this.props.styles.answerTypeWrapper
      }, this.renderContentForAnswerType())));
    }
  }]);
}(Component), _defineProperty(_BlankTypeSelect, "displayName", 'BlankTypeSelect'), _defineProperty(_BlankTypeSelect, "componentId", "Quizzes".concat(_BlankTypeSelect.displayName)), _defineProperty(_BlankTypeSelect, "propTypes", {
  answerType: PropTypes.string.isRequired,
  blankPosition: PropTypes.number,
  blankScoringAlgorithm: PropTypes.string.isRequired,
  blankScoringData: PropTypes.object.isRequired,
  choices: PropTypes.array,
  choicesErrors: PropTypes.array,
  disabled: PropTypes.bool,
  useCommonWordbank: PropTypes.bool.isRequired,
  interactionDataErrors: PropTypes.object,
  name: PropTypes.string,
  notifyScreenreader: PropTypes.func.isRequired,
  onModalClose: PropTypes.func,
  onModalOpen: PropTypes.func,
  scoringDataErrors: PropTypes.object,
  updateBlank: PropTypes.func.isRequired,
  updateBlankScoringData: PropTypes.func.isRequired,
  focusOnMount: PropTypes.bool,
  uuid: PropTypes.func,
  validationErrorsFromApi: PropTypes.array,
  wordBankChoices: PropTypes.array,
  styles: PropTypes.object
}), _defineProperty(_BlankTypeSelect, "defaultProps", {
  blankPosition: void 0,
  blankScoringAlgorithm: '',
  blankScoringData: {},
  choices: [],
  choicesErrors: void 0,
  disabled: false,
  interactionDataErrors: void 0,
  name: void 0,
  onModalClose: void 0,
  onModalOpen: void 0,
  scoringDataErrors: void 0,
  focusOnMount: void 0,
  uuid: uuid,
  validationErrorsFromApi: [],
  wordBankChoices: void 0
}), _BlankTypeSelect)) || _class);
export { BlankTypeSelect as default };